import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';
import { findDOMNode } from 'react-dom';
import $ from "jquery";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';

import {booleanConvert, stableSort, getSorting} from '../Common/helpers';
import EnhancedTableHead from '../Common/TableHead/EnhancedTableHead';
import ModalBox from '../Common/Modals/ModalBox';
import Search from '../Common/Search/Search';

import { API } from '../../ws/constants';

class Suppliers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fetchData:null
            ,openModal:false
            ,order:'asc'
            ,orderBy:'Name'
            ,page:0
            ,rowsPerPage:10
            ,tableLoading:false
        };
    }
    componentDidMount() {
        this.setState({tableLoading:true});
        fetch(API + "getsuppliers")
        .then(response => response.json())
        .then(data => this.setState({ fetchData: data, tableLoading:false }));
    }

    deleteRow = (supplierId) => {
        if(window.confirm("Tem a certeza que quer apagar este fornecedor?")){
            this.setState({tableLoading:true});
            fetch(API + 'deletesupplier&supplierid=' + supplierId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message , openModal: true, tableLoading:false });
                $(findDOMNode(this.refs["supplier_" + supplierId])).remove();
            });
        }
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
    }

    handleSearch = (search) => {
        this.setState({ tableLoading:true, page: 0 });
        fetch(API + "searchsuppliers&keyword="+search)
        .then(response => response.json())
        .then(data => this.setState({ fetchData: data, tableLoading:false }));
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    render() {
        const { isAdmin, loginData } = this.props;
        const suppliers = this.state.fetchData!=null ? this.state.fetchData.data : []
              , loadingClass = this.state.tableLoading ? " ajaxLoading" : ""
              , { order, orderBy, rowsPerPage, page } = this.state
              , headerRows = [
                  { id: 'Name', active: true, numeric: false, label: 'Nome' },
                  { id: 'Cellphone', numeric: false, label: 'Telemóvel' },
                  { id: 'Email', numeric: false, label: 'Email' },
                  { id: 'IsActive', numeric: false, className: 'smallerHeader', label: 'Ativo' },
                  { id: 'actions', notSortable: true, label: 'Ações' },
              ];

        return (
            <div id="suppliersPage">
                <div>
                    <div className="row">
                        <Search searchCallback={this.handleSearch}
                                className="col-12 col-md-4"/>
                    </div>
                    <div className="pageHeader">
                        <h1>
                            <i className="fa fa-dolly"></i> Fornecedores <span className="arrayCount">({suppliers.length})</span>
                            { (isAdmin || loginData.profile.Suppliers.ADD) && 
                                <span className="float-right">
                                    <Tooltip
                                        title={"Adicionar Fornecedor"}
                                        enterDelay={200}>
                                        <span><NavLink className="actionButton success" to={"/Suppliers/New"}><i className="fa fa-plus"></i></NavLink></span>
                                    </Tooltip>
                                </span>
                            }
                        </h1>
                    </div>
                    <Table className={"responsiveTable customTable" + loadingClass}>
                        <EnhancedTableHead
                            className="tableRow tableHeader"
                            headerRows={headerRows}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={this.handleRequestSort}
                            rowCount={suppliers.length}>
                        </EnhancedTableHead>
                        <TableBody>
                            {stableSort(suppliers, getSorting(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map(supplier =>
                            <TableRow key={supplier.Id} className="tableRow" ref={"supplier_" + supplier.Id}>
                                <TableCell  data-title="Nome" className="tableCell">{supplier.Shortname + " - " + supplier.Name}</TableCell >
                                <TableCell  data-title="Telefone" className="tableCell">{supplier.Cellphone}</TableCell >
                                <TableCell  data-title="Email" className="tableCell">{supplier.Email}</TableCell >
                                <TableCell  data-title="Ativo" className="tableCell">{booleanConvert(supplier.IsActive)}</TableCell >
                                <TableCell  data-title="Ações" className="tableCell actions" data-row-id={supplier.Id}>
                                    {(isAdmin || loginData.profile.Suppliers.permission === 1) &&
                                        <Tooltip
                                            title={"Editar Fornecedor"}
                                            enterDelay={200}>
                                            <span><NavLink className="actionButton warning" to={"/Suppliers/"+supplier.Id}><i className="fa fa-pencil-alt"></i></NavLink></span>
                                        </Tooltip>
                                    }
                                    {loginData.profile.Suppliers && loginData.profile.Suppliers.permission === 2 &&
                                        <Tooltip
                                            title={"Ver Fornecedor"}
                                            enterDelay={200}>
                                            <span><NavLink className="actionButton success" to={"/Suppliers/"+supplier.Id}><i className="fa fa-eye"></i></NavLink></span>
                                        </Tooltip>
                                    }
                                    {(isAdmin || loginData.profile.Suppliers.DEL) &&
                                        <Tooltip
                                            title={"Eliminar Fornecedor"}
                                            enterDelay={200}>
                                            <span><button type="button" className="simpleBtn actionButton danger" onClick={() => this.deleteRow(supplier.Id)}><i className="fa fa-times"></i></button></span>
                                        </Tooltip>
                                    }
                                </TableCell >
                            </TableRow>
                            )}
                        </TableBody>
                    </Table>
				</div>
                <div className="row">
                    <div className="col-12">
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={suppliers.length}
                            rowsPerPage={rowsPerPage}
                            labelRowsPerPage="Linhas por página:"
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            page={page}
                            backIconButtonProps={{
                                'aria-label': 'Página anterior',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'Próxima página',
                            }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        />
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}

export default Suppliers;
